import {Base64} from 'js-base64';
import Cookies from 'universal-cookie';
import moment from 'moment';
import {activateLayer, updateMapProperties} from '../actions';

/**
 * set dynamic url layers
 *
 * @param activeLayers
 */
export function setDynamicUrlLayers(activeLayers){
    let newActiveLayers = [];

    activeLayers.forEach((layer) => {
        if(!layer.is_adhoc) {
            let newLayer = {
                id       : layer.id,
                subLayers: [],
                opacity  : layer.opacity,
                hide     : layer.hide,
            }
            if (layer.layer_active) {
                newLayer.layer_time = layer.layer_active.layer_time;
                layer.layer_active.layer_lists.forEach((subLayer) => {
                    newLayer.subLayers.push({
                        id          : subLayer.id,
                        is_active   : subLayer.is_active,
                        layer_filter: subLayer.layer_filter
                    })
                });
            }
            newActiveLayers.push(newLayer);
        }
    });

    window.dynamicUrlObj.layers = newActiveLayers;
    updateDynamicUrl();
}

/**
 * set dynamic url map properties
 *
 * @param mapProperties
 */
export function setDynamicUrlMapProperties(mapProperties){
    window.dynamicUrlObj.mapProperties = mapProperties
    updateDynamicUrl();
}

/**
 * update dynamic url on url & cookies
 */
export function updateDynamicUrl(){
    if(window.queryUrlLoaded) {
        const baseUrl = location.protocol + '//' + location.host + location.pathname;
        const queryString = Base64.encodeURI(JSON.stringify(window.dynamicUrlObj));
        const newUrl = baseUrl + '?q=' + queryString;

        /* update url new url*/
        window.history.pushState('obj', 'PRIMS', newUrl);

        /* update cookies */
        const cookies = new Cookies();
        cookies.set('prims_dynamic_url', queryString, {path: '/', expires: moment().add(3,'days').toDate()});
    }
}

/**
 * helper to check valid json
 *
 * @param str
 * @returns {boolean}
 */
export function isJSON(str) {
    try {
        const obj = JSON.parse(str);
        if (obj && typeof obj === 'object' && obj !== null) {
            return true;
        }
    } catch (err) {}
    return false;
}